import { render, staticRenderFns } from "./ChemicalManager.vue?vue&type=template&id=5a93bce7&"
import script from "./ChemicalManager.vue?vue&type=script&lang=js&"
export * from "./ChemicalManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChemicalManager.vue"
export default component.exports